import { initialStaffState, StaffActionTypes } from '../types';
import createAsyncReducer from '~lib/shared/redux/reducers/async-reducer';
const ListStaffPublicReducer = createAsyncReducer(StaffActionTypes.LIST_STAFF_PUBLIC, initialStaffState.listStaffPublic);
export default ListStaffPublicReducer;
